module.exports = __webpack_public_path__ + "assets/img/2021-9-active.fd777bb9.png";